import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService } from '@tcc-mono/shared/data-access';
import { BookingItem } from '@tcc-mono/vandijk/shared/data-access/models';

@Injectable({
  providedIn: 'root'
})
export class BookingItemService extends BaseService<BookingItem> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/booking-items'
  }
}
